import { VendasGraficoPotencia } from './vendas-grafico-potencia';

export class Dashboard {
  valoresOrcamentos: ValoresDashboard;
  valoresPedidos: ValoresDashboard;
  valoresGraficoQuantidades: ValorGraficoDashboard[];
  valoresGraficoValores: ValorGraficoDashboard[];
  valoresGraficoPotencias: ValorGraficoDashboard[];
  dataInicio: Date;
  dataFim: Date;
  totalRecebimentos: number;
  totalAguardandoConfirmacao: number;
  totalAguardandoPagamento: number;
  vendas: any[];
  vendasOrcamentosUltimos: any[];
  vendasGraficoPotencia: VendasGraficoPotencia;
}

export class ResultadosPeriodoDashboard {
  valoresOrcamentos: ValoresDashboard;
  valoresPedidos: ValoresDashboard;
  dataInicio: Date;
  dataFim: Date;
}

export class DadosDashboardDefault {
  dataInicio: Date;
  dataFim: Date;
}

export class ResultVendasUltOrcPed extends DadosDashboardDefault {
  vendasOrcamentosUltimos: any[];
}

export class ResultDadosGraficos extends DadosDashboardDefault {
  valoresGraficoQuantidades: ValorGraficoDashboard[];
  valoresGraficoValores: ValorGraficoDashboard[];
  valoresGraficoPotencias: ValorGraficoDashboard[];
}

export class ResultTotais extends DadosDashboardDefault {
  totalRecebimentos: number;
  totalAguardandoConfirmacao: number;
  totalAguardandoPagamento: number;
}

export class ValoresDashboard{
  valorTotal: number;
  qtdTotal: number;
  potenciaTotal: number;
  potenciaTotalTexto: string;
}

export class ValorGraficoDashboard{
  name: string;
  value: number;
  id: number;
}
